"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_TREE_NODE_FRAGMENT = void 0;
const client_1 = require("@apollo/client");
exports.PRODUCT_TREE_NODE_FRAGMENT = (0, client_1.gql)(`
  fragment ProductTreeNodeFragment on ProductTreeNode {
    id
    title
    description
    descendants {
      totalCount
    }
  }
`);
